export function abortableDelay(milliseconds, signal) {
    return new Promise((resolve, reject) => {
        if (signal?.aborted) {
            reject(signal?.reason ?? new DOMException("Aborted", "AbortError"));
            return;
        }
        const cleanup = () => signal?.removeEventListener("abort", abort);
        const timeout = setTimeout(() => {
            cleanup();
            resolve();
        }, milliseconds);
        const abort = () => {
            clearTimeout(timeout);
            cleanup();
            reject(signal?.reason ?? new DOMException("Aborted", "AbortError"));
        };
        signal?.addEventListener("abort", abort, { once: true });
    });
}
